/**
 * Slider
 */

const Slider = (function($) {
  "use strict";

  function init() {
    if ($(".Slider").length) {
      $(".Slider-slider").slick({
        adaptiveHeight: true,
        arrows: false,
        dots: true,
        speed: 800
      });
    }

    if ($(".Gallery").length) {
      $(".Gallery-carousel").slick({
        autoplay: true,
        speed: 800
      });
    }

    if ($(".ClientRing-slider".length)) {
      $(".ClientRing-slider").slick({
        adaptiveHeight: true,
        arrows: false,
        dots: true,
        speed: 800
      });

      $(".ClientRing-slide").on("click", "img", function() {
        $(".ClientRing-slider").slick("slickNext");
      });
    }
  }

  return {
    init
  };
})(jQuery);

jQuery(document).ready(Slider.init);
